import React from "react";
import { CONSTANT } from "../../../../../constant/Constant";

export default function GridGallery({ images }) {
  const imgUrl = (img) => {
    return `${CONSTANT.UI_URL}images/${img}`;
  };
  return (
    <div className="flex w-full justify-center items-center">
      <div className="grid grid-cols-3 grid-rows-3  p-4 w-[75%]">
        <div className="col-span-1 row-span-1  aspect-[1/1] p-2">
          <img
            src={imgUrl(images[0])}
            alt="Gallery 1"
            className="h-full w-full object-cover  rounded-xl"
          />
        </div>
        <div className="col-span-1 row-span-2 aspect-[1/2] p-2">
          <img
            src={imgUrl(images[1])}
            alt="Gallery 2"
            className="w-full h-full object-cover rounded-xl"
          />
        </div>
        <div className="col-span-1 row-span-1 aspect-[1/1] p-2">
          <img
            src={imgUrl(images[2])}
            alt="Gallery 3"
            className="w-full h-full object-cover rounded-xl"
          />
        </div>
        <div className="col-span-1 row-span-1 aspect-[1/1] p-2">
          <img
            src={imgUrl(images[3])}
            alt="Gallery 4"
            className="w-full h-full object-cover rounded-xl"
          />
        </div>
        <div className="col-span-1 row-span-2 aspect-[1/2] p-2">
          <img
            src={imgUrl(images[4])}
            alt="Gallery 5"
            className="w-full h-full object-cover rounded-xl"
          />
        </div>
        <div className="col-span-2 row-span-1 aspect-[2/1] p-2">
          <img
            src={imgUrl(images[5])}
            alt="Gallery 6"
            className="w-full h-full object-cover rounded-xl"
          />
        </div>
      </div>
    </div>
  );
}
